import { Caption, Flex, pxToRem, useStyles } from '@archipro-design/aria';
import * as S from './Contacts.mobile.style';
import type { ProjectPageLoader } from '@modules/project/type';
import ProjectMobileCTAButtons from './ProjectMobileCTAButtons';

interface ContactsProps {
    project: ProjectPageLoader['project'];
    showEnquiryCTA?: boolean;
    showSpecifierLoginPrompt?: boolean;
}

const Contacts = ({
    project,
    showEnquiryCTA = true,
    showSpecifierLoginPrompt = false,
}: ContactsProps) => {
    const { css } = useStyles();
    const { Professional } = project;

    return (
        <Flex column className={css(S.Contacts)}>
            <ProjectMobileCTAButtons
                project={project}
                showEnquiryCTA={showEnquiryCTA}
                showSpecifierLoginPrompt={showSpecifierLoginPrompt}
                showWebsiteCTA
            />
            {Professional.EnquiryResponseRate &&
            Professional.EnquiryResponseRate >= 40 ? (
                <div className={css(S.ResposeRate)}>
                    <Caption
                        variant="02"
                        variables={{
                            letterSpacing: 'normal',
                            fontSize: pxToRem(14),
                        }}
                    >
                        {`Responds within 24 hours: ${Professional.EnquiryResponseRate}%`}
                    </Caption>
                </div>
            ) : null}
        </Flex>
    );
};

export default Contacts;
